import { orderBy, query, Unsubscribe } from 'firebase/firestore';
import { useMemo } from 'react';
import { useShallow } from 'zustand/shallow';
import { DailyStatistics, DailyStatisticsConverter, StatisticsCollection } from '../dto/statistics';
import { useDataStore } from '../stores/data.store';
import { useFirebase } from './firebase.hook';

export interface StatisticsInterface {
  loadStatistics(): Unsubscribe;
  resetStatistics(): void;
  statisticsLoading: boolean;
  statistics: DailyStatistics[];
}

export function useStatistics(): StatisticsInterface {
  const { collection, querySubscribe } = useFirebase();

  const [storeStatistics, setStoreStatistics] = useDataStore(
    useShallow((s) => [s.statistics, s.setStatistics]),
  );

  function loadStatistics(): Unsubscribe {
    return querySubscribe<DailyStatistics>(
      query(collection(StatisticsCollection).withConverter(DailyStatisticsConverter), orderBy('date', 'asc')),
      setStoreStatistics,
    );
  }

  function resetStatistics(): void {
    setStoreStatistics(undefined);
  }

  return useMemo(
    () => ({
      loadStatistics,
      resetStatistics,
      statisticsLoading: !storeStatistics,
      statistics: storeStatistics ?? [],
    }),
    [storeStatistics, collection, querySubscribe],
  );
}
